import { RouterType } from '@online-webinar/router';
import { SurveyResults } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/survey-result'].update({
        staticData: { title: { page: 'Insights.Survey.PageHeading', forWebinar: true } },
        component: authGuard(SurveyResults, { canBroadcast: true })
    });
};
